import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pedido-antecipacao',
  templateUrl: './pedido-antecipacao.component.html',
  styleUrls: ['./pedido-antecipacao.component.css']
})
export class PedidoAntecipacaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
